import { createStyles } from "@mantine/emotion";

export default createStyles ( {
	emoteContainer: {
		width         : "20px",
		display       : "inline-flex",
		marginTop     : "-0.6rem",
		verticalAlign : "-webkit-baseline-middle"
	},
	emote: {
		height: "20px"
	}
} );
